import React, { useRef, useEffect, useMemo, useCallback } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import ITypeGroupeUnite from "../../models/ITypeGroupeUnite";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useEnum from '../../hooks/useEnum';
import { useContextPopupPage } from '../../components/popups/PopupPage';
import "./gestion-groupes-types-unites.css";

interface IGestionGroupesTypesUnitesProps {
  isModeSelection?: boolean,
}

export default function GestionGroupesTypesUnites({ isModeSelection }: IGestionGroupesTypesUnitesProps) {
  const typeUniteFormDataSource = useCustomDataSource<ITypeGroupeUnite, ITypeGroupeUnite>({ path: "typeUniteGroupe", primaryKey: "idTypeUniteGroupe" });
  const { setMainForm, selectedDataRow: selectedGroupeTypeUnite, mode, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged } = typeUniteFormDataSource;
  const formRef = useRef<FormRef>(null);
  const { setSelectedValue } = useContextPopupPage();

  const { editorOptions: gestionDureesEditorOptions } = useEnum(undefined, 'gestionDurees', '100px');
  const { editorOptions: gestionOrdreTriEditorOptions } = useEnum(undefined, 'gestionOrdreTri');

  const spinOptions = useMemo(() => {
    return {
      width: 75,
      min: 1,
      showSpinButtons: true
    }
  }, []);

  useEffect(() => {
    const formInstance = formRef.current?.instance();
    if (formInstance) {
      setMainForm(formInstance);
      formInstance.option('customizeItem', (item: any) => {
        if (item.editorType === 'dxNumberBox' && (item.dataField === 'dureePeriode' || item.dataField === 'nombreColonnes' || item.dataField === 'tailleColonne')) {
          const originalEditorOptions = item.editorOptions || {};
          item.editorOptions = {
            ...originalEditorOptions,
            ...spinOptions,
            showLoadingIndicator: false
          };
        }
      });
    }
  }, [spinOptions])

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  const descriptionOptions = useMemo(() => {
    return { maxLength: 50 };
  }, []);
  const actifOptions = useMemo(() => {
    return { text: "Actif" };
  }, []);

  return (
    <FormListBase data={typeUniteFormDataSource}>
      <FormListBaseGrid
        dataSource={typeUniteFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Lecture)
            setMode(Mode.Lecture)
          if (setSelectedValue && e.row?.data)
            setSelectedValue(e.row.data);
        }}>
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedGroupeTypeUnite?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedGroupeTypeUnite || {} as ITypeGroupeUnite} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem>
                <GroupItem colCount={2}>
                  <SimpleItem key={"frm-description"} dataField={"description"}
                    editorOptions={
                      descriptionOptions
                    } />
                  <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                    editorOptions={
                      actifOptions
                    }
                  >
                    <Label visible={false} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem colCount={2} cssClass='noflexitemgroup'>
                  <SimpleItem cssClass='noflexitem-groupe-type-unite' key={"frm-duree-periode"} dataField={"dureePeriode"} editorType={"dxNumberBox"}
                    editorOptions={spinOptions}
                  >
                    <Label text={"Durée de la période"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-type-periode"} dataField={"typePeriode"} editorType={"dxSelectBox"}
                    editorOptions={
                      gestionDureesEditorOptions
                    }
                  >
                    <Label visible={false} text={"Type de période"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem alignItemLabels={false}>
                  <SimpleItem key={"frm-nombre-colonnes"} dataField={"nombreColonnes"} editorType={"dxNumberBox"}
                    editorOptions={spinOptions}
                  >
                    <Label text={"Nombre de colonne(s) à afficher"} />
                  </SimpleItem>
                </GroupItem>
                <SimpleItem key={"frm-taille-colonnes"} dataField={"tailleColonne"} editorType={"dxNumberBox"} editorOptions={spinOptions}
                >
                  <Label text={"Taille des colonnes"} />
                </SimpleItem>
                <SimpleItem key={"frm-tri"} dataField={"tri"} editorType={"dxRadioGroup"}
                  editorOptions={
                    gestionOrdreTriEditorOptions
                  }
                >
                  <Label text={"Ordre de tri"} />
                </SimpleItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedGroupeTypeUnite || {} as ITypeGroupeUnite} /></TabItem>
        </FormListBaseTab> : null}
    </FormListBase>
  );
}